"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _variables = require("../../../global-files/variables");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: fit-content;\n  //margin: 100px 0px 0px 100px;\tmodo dev\n  //border: 1px solid red;\tmodo dev\n\n  + .MuiTooltip-popper {\n    background-color: transparent;\n\n    .MuiTooltip-tooltip {\n      --background: white;\n      box-shadow: 0px 0px 10px 1px gray;\n      background-color: var(--background);\n      padding: 10px;\n      border-radius: 7px;\n      max-width: 60vw;\n      font-family: ", ", sans-serif;\n      font-size: 12px;\n      text-align: left;\n      color: #262626;\n\n      .MuiTooltip-arrow {\n        color: var(--background);\n      }\n    }\n\n    &[data-popper-placement*=\"bottom\"] .MuiTooltip-tooltip {\n      margin-top: 10px;\n    }\n    &[data-popper-placement*=\"top\"] .MuiTooltip-tooltip {\n      margin-bottom: 10px;\n    }\n    &[data-popper-placement*=\"left\"] .MuiTooltip-tooltip {\n      margin-right: 10px;\n    }\n    &[data-popper-placement*=\"right\"] .MuiTooltip-tooltip {\n      margin-left: 10px;\n    }\n  }\n"])), _variables.FontFamily.RobotoMedium);

exports.Container = Container;